<template>
    <div class="text-animation pt-5">
        <div v-for="(item,index) in items" :key="index" class="wrapper-text">
            <transition name="fadeOne">
                <div v-show="item.id == active" class="container">
                    <p class="One">{{item.one}}</p>
                </div>
            </transition>
            <transition name="fadeTwo">
                <div v-show="item.id == active" class="container">
                    <p class="Two">{{item.two}}</p>
                </div>
            </transition>
        </div>

    </div>
</template>

<script>
export default {
  name: 'text-animation',
  data () {
    return {
      show: false,
      activeInterval: null,
      active: -1,
      items: [
        {
          id: 0,
          one: 'مادیا',
          two: 'پلتفرم اشتراک گذاری و فروش ویدئوهای آموزشی'
        },
        {
          id: 1,
          one: 'مادیا',
          two: 'آموزش آنلاین به سبک مادیا'
        },
        // {
        //   id: 2,
        //   one: 'مادیا',
        //   two: 'حرکتی سریع به سمت آینده'
        // },
        {
          id: 3,
          one: 'مادیا',
          two: 'همیشه و همه جا یاد بگیرید'
        },
        {
          id: 4,
          one: 'مادیا',
          two: 'بستری برای رشد مدرسین و دانش پژوهان'
        }
      ]
    }
  },
  created () {
    this.startAnimation()
  },
  methods: {
    startAnimation () {
      var vm = this
      this.activeInterval = setInterval(function () {
        vm.active++
        if (vm.active == 3) {
          vm.active = 0
        }
      }, 5000)
    }
  },
  destroyed () {
    clearInterval(this.activeInterval)
  }
}
</script>

<style scoped>
.container {
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}
.text-animation {
  position: relative;
}
.wrapper-text {
  position: absolute;
  top: 70px;
  right: 0;
  left: 0;
  margin: auto;
}
p {
  text-align: center;
  font-size: 50px;
  font-smoothing: antialiased;
  overflow: hidden;
  color: #fff;
  margin: 1px;
  font-family: iranyekan;
}

.Two {
  font-size: 32px;
  font-family: iranyekan;
}

.fadeOne-enter-active,
.fadeOne-leave-active {
  transition: all 0.5s ease-out;
}
.fadeOne-enter,
.fadeOne-leave-to {
  clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%);
  transform: translate(0%, 100%);
}

.fadeTwo-enter-active,
.fadeTwo-leave-active {
  transition: all 0.5s ease-out;
}
.fadeTwo-enter,
.fadeTwo-leave-to {
  clip-path: polygon(0% 100%, 100% 100%, 0% 100%, 0% 100%);
  transform: translate(0%, -100%);
}
</style>



// WEBPACK FOOTER //
// src/components/min-component/text-loader.vue